<template>
  <div class="tax-table-wrap" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>企业所得税年度纳税申报基础信息表</dt>

      <dd></dd>
    </dl>

    <div class="tax-table-body">
      <p>基本经营情况 （ *为必填项 ）</p>
      <table style="margin-top: 14px" border="1" cellspacing="0" cellpadding="4">
        <tbody>
          <tr class="tr">
            <td class="title01" colspan="2"><span style="color: #ff5353">*</span> 101纳税申报企业类型(填写代码)</td>
            <td colspan="3" class="title01"><el-input v-model.trim="data.v1x1.value" /></td>
            <td class="title01" colspan="2">102分支机构就地纳税比例（%）</td>
            <td colspan="2"><el-input-number v-model.trim="data.v1x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" :min="0" :max="100" /></td>
          </tr>

          <tr class="tr">
            <td class="title01" colspan="3"><span style="color: #ff5353">*</span>103资产总额 <span style="color: #ff5353">（填写平均值，单位：万元）</span></td>
            <td colspan="2">
              <!-- 考题 -->
              <taxQue :data="data.v2x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="title01" colspan="3"><span style="color: #ff5353">*</span>104从业人数 <span style="color: #ff5353">（填写平均值，单位：人）</span></td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v2x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x2.value" :controls="false" :precision="0" :step="1" :value-on-clear="0.0" :min="0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x2.answer" :controls="false" :precision="0" :step="1" :value-on-clear="null" :min="0" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01" colspan="3">105所属国民经济行业(填写代码)</td>
            <td colspan="2" class="title01"><el-input v-model.trim="data.v3x1.value" /></td>
            <td class="title01" colspan="3"><span style="color: #ff5353">*</span>106从事国家限制或禁止行业</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v3x2" :mode="mode">
                <template #input>
                  <el-radio-group v-model="data.v3x2.value">
                    <el-radio value="1">是</el-radio>
                    <el-radio value="-1">否</el-radio>
                  </el-radio-group>

                  <el-button type="danger" link v-if="[2, 5].includes(+mode) && data.v3x2.value" @click="data.v3x2.value = ''">重置</el-button>
                </template>
                <template #score>
                  <el-radio-group v-model="data.v3x2.answer">
                    <el-radio value="1">是</el-radio>
                    <el-radio value="-1">否</el-radio>
                  </el-radio-group>

                  <el-button type="danger" link v-if="[2, 5].includes(+mode) && data.v3x2.answer" @click="data.v3x2.answer = null">重置</el-button>

                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v3x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" colspan="3"><span style="color: #ff5353">*</span>107适用会计准则或会计制度（填写代码）</td>
            <td colspan="2">
              <!-- 考题 -->
              <taxQue :data="data.v4x1" :mode="mode">
                <template #input>
                  <el-select v-model="data.v4x1.value" clearable :value-on-clear="''">
                    <el-option v-for="(item, index) of options1" :value="item.value" :label="item.label" :key="index" />
                  </el-select>
                </template>
                <template #score>
                  <el-select placeholder="请选择答案" v-model="data.v4x1.answer" clearable :value-on-clear="null">
                    <el-option v-for="(item, index) of options1" :value="item.value" :label="item.label" :key="index" />
                  </el-select>

                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v4x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="title01" colspan="3"><span style="color: #ff5353">*</span>108采用一般企业财务报表格式（2019年版）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v4x2" :mode="mode">
                <template #input>
                  <el-radio-group v-model="data.v4x2.value">
                    <el-radio value="1">是</el-radio>
                    <el-radio value="-1">否</el-radio>
                  </el-radio-group>

                  <el-button type="danger" link v-if="[2, 5].includes(+mode) && data.v4x2.value" @click="data.v4x2.value = ''">重置</el-button>
                </template>
                <template #score>
                  <el-radio-group v-model="data.v4x2.answer">
                    <el-radio value="1">是</el-radio>
                    <el-radio value="-1">否</el-radio>
                  </el-radio-group>

                  <el-button type="danger" link v-if="[2, 5].includes(+mode) && data.v4x2.answer" @click="data.v4x2.answer = null">重置</el-button>

                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v4x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" colspan="3"><span style="color: #ff5353">*</span>109小型微利企业</td>
            <td colspan="2">
              <!-- 考题 -->
              <taxQue :data="data.v5x1" :mode="mode">
                <template #input>
                  <el-radio-group v-model="data.v5x1.value">
                    <el-radio value="1">是</el-radio>
                    <el-radio value="-1">否</el-radio>
                  </el-radio-group>

                  <el-button type="danger" link v-if="[2, 5].includes(+mode) && data.v5x1.value" @click="data.v5x1.value = ''">重置</el-button>
                </template>
                <template #score>
                  <el-radio-group v-model="data.v5x1.answer">
                    <el-radio value="1">是</el-radio>
                    <el-radio value="-1">否</el-radio>
                  </el-radio-group>

                  <el-button type="danger" link v-if="[2, 5].includes(+mode) && data.v5x1.answer" @click="data.v5x1.answer = null">重置</el-button>

                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v5x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="title01" colspan="2"><span style="color: #ff5353">*</span>110上市公司</td>
            <td colspan="2">
              <div style="display: flex; justify-content: center; align-items: center">
                是（
                <el-checkbox style="margin: 0 10px" value="1" v-model="data.v5x2.value">境内</el-checkbox>
                <el-checkbox style="margin: 0 10px" value="2" v-model="data.v5x2.value">境外</el-checkbox>
                ）
                <el-checkbox style="margin: 0 10px" value="-1" v-model="data.v5x2.value">否</el-checkbox>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <p style="margin-top: 14px">有关涉税事项情况 ( 存在或者发生下列事项时必填 )</p>
      <table style="margin-top: 14px" border="1" cellspacing="0" cellpadding="4">
        <tbody>
          <tr class="tr">
            <td class="title01">201从事股权投资业务</td>
            <td colspan="2">
              <el-checkbox v-model="data.v6x1.value">是</el-checkbox>
            </td>
            <td class="title01">202存在境外关联交易</td>
            <td colspan="2">
              <el-checkbox v-model="data.v6x2.value">是</el-checkbox>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" rowspan="2">203 境外所得信息</td>
            <td class="title01" colspan="2">203-1 选择采用的境外所得抵免方式</td>
            <td colspan="3">
              <!-- 考题 -->
              <taxQue :data="data.v7x2" :mode="mode">
                <template #input>
                  <el-radio-group v-model="data.v7x2.value">
                    <el-radio value="1">分国（地区）不分项</el-radio>
                    <el-radio value="2">不分国（地区）不分项</el-radio>
                    <el-radio value="-1">否</el-radio>
                  </el-radio-group>

                  <el-button type="danger" link v-if="[2, 5].includes(+mode) && data.v7x2.value" @click="data.v7x2.value = ''">重置</el-button>
                </template>
                <template #score>
                  <el-radio-group v-model="data.v7x2.answer">
                    <el-radio value="1">分国（地区）不分项</el-radio>
                    <el-radio value="2">不分国（地区）不分项</el-radio>
                    <el-radio value="-1">否</el-radio>
                  </el-radio-group>

                  <el-button type="danger" link v-if="[2, 5].includes(+mode) && data.v7x2.answer" @click="data.v7x2.answer = null">重置</el-button>

                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v7x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" colspan="2">203-2 海南自由贸易港新增境外直接投资信息</td>
            <td colspan="3">
              <div style="display: flex; justify-content: center; align-items: center">
                <el-checkbox style="margin: 0 10px" value="1" v-model="data.v8x2.value">是</el-checkbox>
                （
                <el-checkbox style="margin: 0 10px" value="2" v-model="data.v8x2.value">旅游业</el-checkbox>
                <el-checkbox style="margin: 0 10px" value="3" v-model="data.v8x2.value">境外</el-checkbox>
                <el-checkbox style="margin: 0 10px" value="4" v-model="data.v8x2.value">高新技术产业</el-checkbox>
                ）
              </div>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01">204有限合伙制创业投资企业的法人合伙人</td>
            <td colspan="2">
              <el-checkbox v-model="data.v9x1.value">是</el-checkbox>
            </td>
            <td class="title01">205创业投资企业</td>
            <td colspan="2">
              <el-checkbox v-model="data.v9x2.value">是</el-checkbox>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01">206技术先进型服务企业类型（填写代码）</td>
            <td colspan="2">
              <el-select></el-select>
            </td>
            <td class="title01">207非营利组织</td>
            <td colspan="2">
              <el-checkbox v-model="data.v10x2.value">是</el-checkbox>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01">208软件、集成电路企业类型（填写代码）</td>
            <td colspan="2">
              <el-select></el-select>
            </td>
            <td class="title01">209集成电路生产项目类型</td>
            <td colspan="2">
              <div style="display: flex; justify-content: center; align-items: center">
                <el-checkbox style="margin: 0 10px" value="1" v-model="data.v11x2.value">130纳米</el-checkbox>
                <el-checkbox style="margin: 0 10px" value="2" v-model="data.v11x2.value">65纳米</el-checkbox>
                <el-checkbox style="margin: 0 10px" value="3" v-model="data.v11x2.value">28纳米</el-checkbox>
              </div>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" rowspan="2">210 &nbsp; 科技型中小企业</td>
            <td class="title01">210-1_年（申报所属期年度）入库编号 1</td>
            <td>
              <el-input v-model.trim="data.v12x1.value" />
            </td>
            <td class="title01">210-2 入库时间 1</td>
            <td colspan="2">
              <el-input v-model.trim="data.v12x2.value" />
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">210-3_年（申报所属期年度）入库编号 2</td>
            <td>
              <el-input v-model.trim="data.v13x1.value" />
            </td>
            <td class="title01">210-4 入库时间 2</td>
            <td colspan="2">
              <el-input v-model.trim="data.v13x2.value" />
            </td>
          </tr>

          <tr class="tr">
            <td class="title01" rowspan="2">211 高新科技企业申报所属期年度有效的高新技术企业证书</td>
            <td class="title01">211-1_年 证书编号 1</td>
            <td>
              <el-input v-model.trim="data.v14x1.value" />
            </td>
            <td class="title01">211-2 发证时间 1</td>
            <td colspan="2">
              <el-input v-model.trim="data.v14x2.value" />
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">211-3_年 证书编号 2</td>
            <td>
              <el-input v-model.trim="data.v15x1.value" />
            </td>
            <td class="title01">211-4 发证时间 2</td>
            <td colspan="2">
              <el-input v-model.trim="data.v15x2.value" />
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">212重组事项税务处理方式</td>
            <td colspan="2">
              <div style="display: flex; justify-content: center; align-items: center">
                <el-checkbox style="margin: 0 10px" value="1" v-model="data.v16x1.value">一般性</el-checkbox>
                <el-checkbox style="margin: 0 10px" value="2" v-model="data.v16x1.value">特殊性</el-checkbox>
              </div>
            </td>
            <td class="title01">213重组交易类型（填写代码）</td>
            <td colspan="2">
              <el-input v-model.trim="data.v16x2.value" />
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">214重组当事方式类型（填写代码）</td>
            <td colspan="2">
              <el-input v-model.trim="data.v17x1.value" />
            </td>
            <td class="title01">215政策性搬迁开始时间</td>
            <td colspan="2">
              <el-date-picker v-model="data.v17x2.value" type="month" value-format="YYYY-MM" placeholder="请选择" :clearable="false" value-on-clear="" />
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">216发生政策性搬迁且停止生产经营无所得年度</td>
            <td colspan="2">
              <el-checkbox v-model="data.v18x1.value">是</el-checkbox>
            </td>
            <td class="title01">217政策性搬迁损失分期扣除年度</td>
            <td colspan="2">
              <el-checkbox v-model="data.v18x2.value">是</el-checkbox>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01">218发生非货币性资产对外投资递延纳税事项</td>
            <td colspan="2">
              <el-checkbox v-model="data.v19x1.value">是</el-checkbox>
            </td>
            <td class="title01">219非货币性资产对外投资转让所得递延纳税年度</td>
            <td colspan="2">
              <el-checkbox v-model="data.v19x2.value">是</el-checkbox>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01">220发生技术成果投资入股递延纳税事项</td>
            <td colspan="2">
              <el-checkbox v-model="data.v20x1.value">是</el-checkbox>
            </td>
            <td class="title01">221技术成果投资入股递延纳税年度</td>
            <td colspan="2">
              <el-checkbox v-model="data.v20x2.value">是</el-checkbox>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01">222发生资产（股权）划转特殊性税务处理事项</td>
            <td colspan="2">
              <el-checkbox v-model="data.v21x1.value">是</el-checkbox>
            </td>
            <td class="title01">223债务重组所得递延纳税年度</td>
            <td colspan="2">
              <el-checkbox v-model="data.v21x2.value">是</el-checkbox>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01">224 研发支出辅助账样式</td>
            <td colspan="5">
              <!-- 考题 -->
              <taxQue :data="data.v22x1" :mode="mode">
                <template #input>
                  <el-radio-group v-model="data.v22x1.value">
                    <el-radio value="1">2015版</el-radio>
                    <el-radio value="2">2021版</el-radio>
                    <el-radio value="3">自行设计</el-radio>
                    <el-radio value="-1">否</el-radio>
                  </el-radio-group>

                  <el-button type="danger" link v-if="[2, 5].includes(+mode) && data.v22x1.value" @click="data.v22x1.value = ''">重置</el-button>
                </template>
                <template #score>
                  <el-radio-group v-model="data.v22x1.answer">
                    <el-radio value="1">2015版</el-radio>
                    <el-radio value="2">2021版</el-radio>
                    <el-radio value="3">自行设计</el-radio>
                    <el-radio value="-1">否</el-radio>
                  </el-radio-group>

                  <el-button type="danger" link v-if="[2, 5].includes(+mode) && data.v22x1.answer" @click="data.v22x1.answer = null">重置</el-button>

                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v22x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
        </tbody>
      </table>
      <p style="margin-top: 14px">主要股东及分红情况</p>
      <table style="margin-top: 14px" border="1" cellspacing="0" cellpadding="4">
        <tbody>
          <tr class="center">
            <td>股东名称</td>
            <td style="min-width: 180px">证件种类</td>
            <td>证件号码</td>
            <td>
              投资比例
              <p>(%)</p>
            </td>
            <td>当年（决议日）分配的股息、红利等权益性投资收益余额</td>
            <td>国籍（注册地址）</td>
          </tr>
          <tr class="tr center">
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v23x1" :mode="mode">
                <template #input>
                  <el-input v-model.trim="data.v23x1.value" />
                </template>
                <template #score>
                  <el-input v-model.trim="data.v23x1.answer" placeholder="答案" :value-on-clear="null" />

                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v23x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v23x2" :mode="mode">
                <template #input>
                  <el-select v-model="data.v23x2.value" clearable :value-on-clear="''">
                    <el-option v-for="(item, index) of options2" :value="item.value" :label="item.label" :key="index" />
                  </el-select>
                </template>
                <template #score>
                  <el-select v-model="data.v23x2.answer" placeholder="请选择答案" clearable :value-on-clear="null">
                    <el-option v-for="(item, index) of options2" :value="item.value" :label="item.label" :key="index" />
                  </el-select>

                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v23x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v23x3" :mode="mode">
                <template #input>
                  <el-input v-model.trim="data.v23x3.value" />
                </template>
                <template #score>
                  <el-input v-model.trim="data.v23x3.answer" placeholder="答案" :value-on-clear="null" />

                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v23x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v23x4" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v23x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" :max="100" :min="0" />
                </template>
                <template #score>
                  <el-input-number v-model.trim="data.v23x4.answer" placeholder="答案" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" :max="100" :min="0" />

                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v23x4.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td>
              <el-input-number v-model.trim="data.v23x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v23x6" :mode="mode">
                <template #input>
                  <el-select v-model="data.v23x6.value" clearable :value-on-clear="''">
                    <el-option v-for="(item, index) of options3" :value="item.value" :label="item.label" :key="index" />
                  </el-select>
                </template>
                <template #score>
                  <el-select v-model="data.v23x6.answer" placeholder="请选择答案" clearable :value-on-clear="null">
                    <el-option v-for="(item, index) of options3" :value="item.value" :label="item.label" :key="index" />
                  </el-select>

                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v23x6.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr center">
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v24x1" :mode="mode">
                <template #input>
                  <el-input v-model.trim="data.v24x1.value" />
                </template>
                <template #score>
                  <el-input v-model.trim="data.v24x1.answer" placeholder="答案" :value-on-clear="null" />

                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v24x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v24x2" :mode="mode">
                <template #input>
                  <el-select v-model="data.v24x2.value" clearable :value-on-clear="''">
                    <el-option v-for="(item, index) of options2" :value="item.value" :label="item.label" :key="index" />
                  </el-select>
                </template>
                <template #score>
                  <el-select v-model="data.v24x2.answer" placeholder="请选择答案" clearable :value-on-clear="null">
                    <el-option v-for="(item, index) of options2" :value="item.value" :label="item.label" :key="index" />
                  </el-select>

                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v24x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v24x3" :mode="mode">
                <template #input>
                  <el-input v-model.trim="data.v24x3.value" />
                </template>
                <template #score>
                  <el-input v-model.trim="data.v24x3.answer" placeholder="答案" :value-on-clear="null" />

                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v24x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v24x4" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v24x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" :max="100" :min="0" />
                </template>
                <template #score>
                  <el-input-number v-model.trim="data.v24x4.answer" placeholder="答案" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" :max="100" :min="0" />

                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v24x4.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td>
              <el-input-number v-model.trim="data.v24x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v24x6" :mode="mode">
                <template #input>
                  <el-select v-model="data.v24x6.value" clearable :value-on-clear="''">
                    <el-option v-for="(item, index) of options3" :value="item.value" :label="item.label" :key="index" />
                  </el-select>
                </template>
                <template #score>
                  <el-select v-model="data.v24x6.answer" placeholder="请选择答案" clearable :value-on-clear="null">
                    <el-option v-for="(item, index) of options3" :value="item.value" :label="item.label" :key="index" />
                  </el-select>

                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v24x6.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr center">
            <td colspan="2">其余股东合计</td>
            <td>投资比例</td>
            <td><el-input-number v-model.trim="data.v25x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" :max="100" :min="0" /></td>
            <td class="title01">当年（决议日）分配的股息、红利等权益性投资收益金额</td>
            <td><el-input-number v-model.trim="data.v25x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";
import { syncAnswer } from "../../cmjs/index.js";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};

const watchData = computed(() => cloneDeep(data.value));
function watchStart() {
  watch(
    watchData,
    (newVal, oldVal) => {
      try {
        ["v5x2", "v8x2", "v11x2", "v16x1"].forEach((key) => {
          if (data.value[key].value.length > 1) {
            data.value[key].value = [data.value[key].value[data.value[key].value.length - 1]]; // 只保留最后一个元素
          }
        });

        syncAnswer({
          mode,
          newVal,
          oldVal,
          data,
        });
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

const options1 = [
  { value: "110", label: "110 企业会计准则-一般企业" },
  { value: "120", label: "120 企业会计准则-银行" },
  { value: "130", label: "130 企业会计准则-证券" },
  { value: "140", label: "140 企业会计准则-保险" },
  { value: "150", label: "150 企业会计准则-担保" },
  { value: "200", label: "200 小企业会计准则" },
  { value: "300", label: "300 企业会计制度" },
  { value: "999", label: "999 其他" },
];

const options2 = [
  { value: "1", label: "居民身份证" },
  { value: "2", label: "中国护照" },
  { value: "3", label: "组织机构代码证" },
  { value: "4", label: "军官证" },
  { value: "5", label: "士兵证" },
];

const options3 = [{ value: "1", label: "156/中华人民共和国" }];

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss">
.tax-table-wrap {
  width: 1200px !important;
}
</style>

<script>
const tableHtml = `
  <div class="titleText" style="margin-top: 14px">基本经营情况 （ *为必填项 ）</div>
  <table style="margin-top: 14px" border="1" cellspacing="0" cellpadding="4">
    <tbody>
      <tr class="tr">
        <td class="title01" colspan="2"><span class="red">*</span> 101纳税申报企业类型(填写代码)</td>
        <td colspan="3" class="title01">（系统自动生成）</td>
        <td class="title01" colspan="2">102分支机构就地纳税比例（%）</td>
        <td colspan="2"><input class="input1" type="text" daan="0" /></td>
      </tr>
      <tr class="tr">
        <td class="title01" colspan="3"><span class="red">*</span>103资产总额 <span class="red">（填写平均值，单位：万元）</span></td>
        <td colspan="2"><input class="input2" type="text" daan="294.4" /></td>
        <td class="title01" colspan="3"><span class="red">*</span>104从业人数 <span class="red">（填写平均值，单位：人）</span></td>
        <td><input class="input2" type="text" daan="153" /></td>
      </tr>
      <tr class="tr">
        <td class="title01" colspan="3">105所属国民经济行业(填写代码)</td>
        <td colspan="2" class="title01">（系统自动生成）</td>
        <td class="title01" colspan="3"><span class="red">*</span>106从事国家限制或禁止行业</td>
        <td>
          <input type="text" style="display: none" daan="0" />
          <input type="radio" name="radio1" value="是" />
          是
          <input type="radio" name="radio1" value="否" />
          否
        </td>
      </tr>
      <tr class="tr">
        <td class="title01" colspan="3"><span class="red">*</span>107适用会计准则或会计制度（填写代码）</td>
        <td colspan="2">
          <input type="text" style="display: none" daan="300 企业会计制度" />
          <select name="" id="" class="input2">
            <option value="110 企业会计准则-一般企业">110 企业会计准则-一般企业</option>
            <option value="120 企业会计准则-银行">120 企业会计准则-银行</option>
            <option value="130 企业会计准则-证券">130 企业会计准则-证券</option>
            <option value="140 企业会计准则-保险">140 企业会计准则-保险</option>
            <option value="150 企业会计准则-担保">150 企业会计准则-担保</option>
            <option value="200 小企业会计准则">200 小企业会计准则</option>
            <option value="300 企业会计制度">300 企业会计制度</option>
            <option value="999 其他">999 其他</option>
          </select>
        </td>
        <td class="title01" colspan="3"><span class="red">*</span>108采用一般企业财务报表格式（2019年版）</td>
        <td>
          <input type="text" style="display: none" daan="0" />
          <input type="radio" name="radio2" value="是" />
          是
          <input type="radio" name="radio2" value="否" />
          否
        </td>
      </tr>
      <tr class="tr">
        <td class="title01" colspan="3"><span class="red">*</span>109小型微利企业</td>
        <td colspan="2">
          <input type="text" style="display: none" daan="1" />
          <input type="radio" name="radio3" value="是" />
          是
          <input type="radio" name="radio3" value="否" />
          否
        </td>
        <td class="title01" colspan="2"><span class="red">*</span>110上市公司</td>
        <td colspan="2">
          <input type="text" style="display: none" daan="0" />
          是（
          <input type="checkbox" name="checkbox1" value="境内" />
          境内
          <input type="checkbox" name="checkbox1" value="境外" />
          境外）
          <input type="checkbox" name="checkbox1" value="否" />
          否
        </td>
      </tr>
    </tbody>
  </table>
  <div class="titleText" style="margin-top: 14px">有关涉税事项情况 ( 存在或者发生下列事项时必填 )</div>
  <table style="margin-top: 14px" border="1" cellspacing="0" cellpadding="4">
    <tbody>
      <tr class="tr">
        <td class="title01">201从事股权投资业务</td>
        <td colspan="2">
          <input type="text" style="display: none" daan="0" />
          <input type="checkbox" name="checkbox2" value="是" />是
        </td>
        <td class="title01">202存在境外关联交易</td>
        <td colspan="2">
          <input type="text" style="display: none" daan="0" />
          <input type="checkbox" name="checkbox3" value="是" />是
        </td>
      </tr>
      <tr class="tr">
        <td class="title01" rowspan="2">203 境外所得信息</td>
        <td class="title01" colspan="2">203-1 选择采用的境外所得抵免方式</td>
        <td colspan="3">
          <input type="text" style="display: none" daan="0" />
          <input type="radio" name="radio4" value="分国（地区）不分项" />分国（地区）不分项 &nbsp; <input type="radio" name="radio4" value="不分国（地区）不分项" />不分国（地区）不分项 &nbsp;
          <input type="radio" name="radio4" value="否" />否
        </td>
      </tr>
      <tr class="tr">
        <td class="title01" colspan="2">203-2 海南自由贸易港新增境外直接投资信息</td>
        <td colspan="3">
          <input type="text" style="display: none" daan="0" />
          <input type="checkbox" name="checkbox4" value="是" />是 &nbsp;（ <input type="checkbox" name="checkbox4" value="旅游业" />旅游业 &nbsp;
          <input type="checkbox" name="checkbox4" value="现代服务业" />现代服务业 &nbsp; <input type="checkbox" name="checkbox4" value="高新技术产业" />高新技术产业）
        </td>
      </tr>
      <tr class="tr">
        <td class="title01">204有限合伙制创业投资企业的法人合伙人</td>
        <td colspan="2">
          <input type="text" style="display: none" daan="0" />
          <input type="checkbox" name="checkbox5" value="是" />是
        </td>
        <td class="title01">205创业投资企业</td>
        <td colspan="2">
          <input type="text" style="display: none" daan="0" />
          <input type="checkbox" name="checkbox6" value="是" />是
        </td>
      </tr>
      <tr class="tr">
        <td class="title01">206技术先进型服务企业类型（填写代码）</td>
        <td colspan="2"><select class="input2"></select></td>
        <td class="title01">207非营利组织</td>
        <td colspan="2">
          <input type="text" style="display: none" daan="0" />
          <input type="checkbox" name="checkbox7" value="是" />是
        </td>
      </tr>
      <tr class="tr">
        <td class="title01">208软件、集成电路企业类型（填写代码）</td>
        <td colspan="2"><select class="input2"></select></td>
        <td class="title01">209集成电路生产项目类型</td>
        <td colspan="2">
          <input type="text" style="display: none" daan="0" />
          <input type="checkbox" name="checkbox8" value="130纳米" />130 纳米 &nbsp; &nbsp; <input type="checkbox" value="65纳米" name="checkbox8" />65纳米&nbsp; &nbsp;
          <input type="checkbox" name="checkbox8" value="28纳米" />28纳米
        </td>
      </tr>
      <tr class="tr">
        <td class="title01" rowspan="2">210 &nbsp; 科技型中小企业</td>
        <td class="title01">210-1_年（申报所属期年度）入库编号 1</td>
        <td><input class="input2" type="text" daan="0" /></td>
        <td class="title01">210-2 入库时间 1</td>
        <td colspan="2"><input class="input2" type="text" daan="0" /></td>
      </tr>
      <tr class="tr">
        <td class="title01">210-3_年（申报所属期年度）入库编号 2</td>
        <td><input class="input2" type="text" daan="0" /></td>
        <td class="title01">210-4 入库时间 2</td>
        <td colspan="2"><input class="input2" type="text" daan="0" /></td>
      </tr>
      <tr class="tr">
        <td class="title01" rowspan="2">211 高新科技企业申报所属期年度有效的高新技术企业证书</td>
        <td class="title01">211-1_年 证书编号 1</td>
        <td><input class="input2" type="text" daan="0" /></td>
        <td class="title01">211-2 入库时间 1</td>
        <td colspan="2"><input class="input2" type="text" daan="0" /></td>
      </tr>
      <tr class="tr">
        <td class="title01">211-3_年 证书编号 2</td>
        <td><input class="input2" type="text" daan="0" /></td>
        <td class="title01">211-4 入库时间 2</td>
        <td colspan="2"><input class="input2" type="text" daan="0" /></td>
      </tr>
      <tr class="tr">
        <td class="title01">212重组事项税务处理方式</td>
        <td colspan="2">
          <input type="text" style="display: none" daan="0" />
          <input type="checkbox" name="checkbox9" value="一般性" />一般性 <input type="checkbox" name="checkbox9" value="特殊性" />特殊性
        </td>
        <td class="title01">213重组交易类型（填写代码）</td>
        <td colspan="2"><input class="input1" type="text" daan="0" /></td>
      </tr>
      <tr class="tr">
        <td class="title01">214重组当事方式类型（填写代码）</td>
        <td colspan="2"><input class="input1" type="text" daan="0" /></td>
        <td class="title01">215政策性搬迁开始时间</td>
        <td colspan="2"><input type="text" style="width: 60px" class="input2" daan="0" />年 <input class="input2" type="text" style="width: 60px" daan="0" />月</td>
      </tr>
      <tr class="tr">
        <td class="title01">216发生政策性搬迁且停止生产经营无所得年度</td>
        <td colspan="2">
          <input type="text" style="display: none" daan="0" />
          <input type="checkbox" name="checkbox10" value="是" />是
        </td>
        <td class="title01">217政策性搬迁损失分期扣除年度</td>
        <td colspan="2">
          <input type="text" style="display: none" daan="0" />
          <input type="checkbox" name="checkbox11" value="是" />是
        </td>
      </tr>
      <tr class="tr">
        <td class="title01">218发生非货币性资产对外投资递延纳税事项</td>
        <td colspan="2">
          <input type="text" style="display: none" daan="0" />
          <input type="checkbox" name="checkbox12" value="是" />是
        </td>
        <td class="title01">219非货币性资产对外投资转让所得递延纳税年度</td>
        <td colspan="2">
          <input type="text" style="display: none" daan="0" />
          <input type="checkbox" name="checkbox13" value="是" />是
        </td>
      </tr>
      <tr class="tr">
        <td class="title01">220发生技术成果投资入股递延纳税事项</td>
        <td colspan="2">
          <input type="text" style="display: none" daan="0" />
          <input type="checkbox" name="checkbox14" value="是" />是
        </td>
        <td class="title01">221技术成果投资入股递延纳税年度</td>
        <td colspan="2">
          <input type="text" style="display: none" daan="0" />
          <input type="checkbox" name="checkbox15" value="是" />是
        </td>
      </tr>
      <tr class="tr">
        <td class="title01">222发生资产（股权）划转特殊性税务处理事项</td>
        <td colspan="2">
          <input type="text" style="display: none" daan="0" />
          <input type="checkbox" name="checkbox16" value="是" />是
        </td>
        <td class="title01">223债务重组所得递延纳税年度</td>
        <td colspan="2">
          <input type="text" style="display: none" daan="0" />
          <input type="checkbox" name="checkbox17" value="是" />是
        </td>
      </tr>
      <tr class="tr">
        <td class="title01">224 研发支出辅助账样式</td>
        <td colspan="5">
          <div style="display: flex; align-items: center">
            <input type="text" style="display: none" daan="0" />
            <input style="margin-left: 15px; margin-right: 5px; height: 18px" type="radio" name="radio5" value="2015版" />2015版
            <input style="margin-left: 15px; margin-right: 5px; height: 18px" type="radio" name="radio5" value="2021版" />2021版
            <input style="margin-left: 15px; margin-right: 5px; height: 18px" type="radio" name="radio5" value="自行设计" />自行设计
            <input style="margin-left: 15px; margin-right: 5px; height: 18px" type="radio" name="radio5" value="否" />否
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="titleText" style="margin-top: 14px">主要股东及分红情况</div>
  <table style="margin-top: 14px" border="1" cellspacing="0" cellpadding="4">
    <tbody>
      <tr class="center">
        <td>股东名称</td>
        <td>证件种类</td>
        <td>证件号码</td>
        <td>
          投资比例
          <p>(%)</p>
        </td>
        <td>当年（决议日）分配的股息、红利等权益性投资收益余额</td>
        <td>国籍（注册地址）</td>
      </tr>
      <tr class="tr center">
        <td><input class="input2" style="text-align: left" type="text" value="" daan="刘天泽" /></td>
        <td>
          <input style="display: none" type="text" daan="居民身份证" />
          <select class="input2" style="text-align: left" type="text" value="">
            <option value="居民身份证">居民身份证</option>
            <option value="中国护照">中国护照</option>
            <option value="组织机构代码证">组织机构代码证</option>
            <option value="军官证">军官证</option>
            <option value="士兵证">士兵证</option>
          </select>
        </td>
        <td><input style="text-align: left" class="input2" type="text" value="" daan="420305197910053000" /></td>
        <td><input class="input2" style="text-align: left" type="text" value="" daan="51" /></td>
        <td><input style="text-align: left" class="input2" type="text" value="" daan="0" /></td>
        <td>
          <input style="display: none" type="text" daan="156/中华人民共和国" />
          <select class="input2" style="text-align: left" type="text" value="">
            <option value="156/中华人民共和国">156/中华人民共和国</option>
          </select>
        </td>
      </tr>
      <tr class="tr center">
        <td><input class="input2" style="text-align: left" type="text" value="" daan="钱中兴" /></td>
        <td>
          <input style="display: none" type="text" daan="居民身份证" />
          <select class="input2" style="text-align: left" type="text" value="">
            <option value="居民身份证">居民身份证</option>
            <option value="中国护照">中国护照</option>
            <option value="组织机构代码证">组织机构代码证</option>
            <option value="军官证">军官证</option>
            <option value="士兵证">士兵证</option>
          </select>
        </td>
        <td><input style="text-align: left" class="input2" type="text" value="" daan="420201198606063000" /></td>
        <td><input class="input2" style="text-align: left" type="text" value="" daan="49" /></td>
        <td><input style="text-align: left" class="input2" type="text" value="" daan="0" /></td>
        <td>
          <input style="display: none" type="text" daan="156/中华人民共和国" />
          <select class="input2" style="text-align: left" type="text" value="">
            <option value="156/中华人民共和国">156/中华人民共和国</option>
          </select>
        </td>
      </tr>
      <tr class="tr center">
        <td colspan="2">其余股东合计</td>
        <td>投资比例</td>
        <td><input class="input2" type="text" value="" daan="0" /></td>
        <td class="title01">当年（决议日）分配的股息、红利等权益性投资收益金额</td>
        <td><input class="input2" type="text" value="" daan="0" /></td>
      </tr>
    </tbody>
  </table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input.*type="text".*>/g, '<el-input-number v-model.trim="defaultValue" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValue = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
